import React, { useCallback, useEffect, useRef, useState } from 'react';
import Handlebars from 'handlebars';

import { ValuesMap } from '@/common/types';
import globalTheme from '@/styles/theme';

// --- Handlebars Helpers (keep these as they are) ---
Handlebars.registerHelper('equals', function (arg1, arg2, options) {
  if (arg1 === arg2) {
    // @ts-ignore
    return options.fn(this);
  }
  return '';
});

Handlebars.registerHelper('or', function () {
  // eslint-disable-next-line prefer-rest-params
  const args = Array.prototype.slice.call(arguments);
  const options = args.pop();

  for (let i = 0; i < args.length; i++) {
    if (args[i]) {
      // @ts-ignore
      return options.fn(this);
    }
  }
  // @ts-ignore
  return options.inverse(this);
});

Handlebars.registerHelper('length', function (context) {
  if (Array.isArray(context) || typeof context === 'string') {
    return context.length;
  }
  return 0;
});

Handlebars.registerHelper('greaterThan', function (a, b, options) {
  // @ts-ignore
  return a > b ? options.fn(this) : options.inverse(this);
});

const DEFAULT_FRAME_SIZE = 560;
const DEFAULT_GAP = 100;
// --- Main Hook ---
const useParseEmailTemplate = () => {
  const [content, setContent] = useState('');
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const renderIframeContent = useCallback(
    (htmlString: string, variables: ValuesMap<string | number | boolean>, style?: React.CSSProperties) => {
      const compiledHtml = htmlString ? Handlebars.compile(htmlString)(variables) : '';
      setContent(compiledHtml);
      return (
        <iframe
          ref={iframeRef}
          content={compiledHtml}
          title="Dynamic HTML Content"
          // scrolling="no"
          style={{
            overflow: 'auto',
            width: '100%',
            height: `${DEFAULT_FRAME_SIZE}px`,
            minHeight: `${DEFAULT_FRAME_SIZE}px`,
            paddingInline: '24px',
            backgroundColor: globalTheme.colors.module,
            borderRadius: globalTheme.rounds.moduleRound,
            ...style,
          }}
        />
      );
    },
    []
  );
  useEffect(() => {
    if (content && iframeRef.current) {
      const iframe = iframeRef.current;
      const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
      if (iframeDocument) {
        iframeDocument.open();
        iframeDocument.write(content);
        iframeDocument.close();

        if (iframe) {
          const body = iframe?.contentWindow?.document.body;
          const htmlElement = iframe?.contentWindow?.document.documentElement;

          const height = Math.max(
            // @ts-ignore
            body?.scrollHeight,
            body?.offsetHeight,
            htmlElement?.clientHeight,
            htmlElement?.scrollHeight,
            htmlElement?.offsetHeight,
            DEFAULT_FRAME_SIZE
          );
          iframe.style.minHeight = `${height + DEFAULT_GAP}px`;
          iframe.style.height = `${height + DEFAULT_GAP}px`;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iframeRef.current]);

  return renderIframeContent;
};

export default useParseEmailTemplate;
